import { Component, Vue, Prop } from 'vue-property-decorator';

import WithRender from './CmsMenu.html';
import './CmsMenu.scss';

@WithRender
@Component({
    components: {
       
    }
})
export default class CmsMenu extends Vue {

    @Prop({ })
    href!: string

    structure : any = {}
   
    mounted() {
        this.loadCmsTemplate()
    }


    onMenuClick() {
        this.$emit('menuclick')
    }
    
    loadCmsTemplate() {
      
        
        fetch(this.href).then(response => {
      //  fetch(config.proxyUrl + encodeURIComponent(this.href)).then(response => {
   
            
            
            response.json().then(data => {
                this.structure = data
                
               
            })
            
        });
    }
}
